import { SET_SELECTED_PAYER_ID } from "../../redux/actions/action.types";

export default function setSelectedPayerId(id: any, stateHandler: any) {
  stateHandler({
    type: SET_SELECTED_PAYER_ID,
    payload: id,
  });
}
